import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import MarketWidget from '../components/MarketWidget.tsx';

export default function CardHub() {
  const { cardId } = useParams();
  const [card, setCard] = useState<any | null>(null);

  useEffect(() => {
    (async () => {
      if (!cardId) return;
      // Brute-force search across sets index for now (optimize later)
      const idx = await fetch('/cards/index.json').then((r) => r.json());
      for (const s of idx) {
        const arr = await fetch(`/cards/${s.slug}.json`).then((r) => r.json());
        const found = arr.find((c: any) => c.id === cardId);
        if (found) { setCard(found); break; }
      }
    })();
  }, [cardId]);

  if (!cardId) return <div className="p-6 text-white">Card not found.</div>;
  if (!card) return <div className="p-6 text-white">Loading…</div>;

  return (
    <div className="p-6 text-white max-w-6xl mx-auto">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Card Image */}
        <div className="lg:col-span-1">
          <img 
            src={card.images?.large || card.images?.small} 
            alt={card.name} 
            className="w-full max-w-sm mx-auto rounded-lg shadow-lg"
          />
        </div>
        
        {/* Card Details */}
        <div className="lg:col-span-1">
          <h1 className="text-3xl font-bold mb-2">{card.name}</h1>
          <div className="opacity-80 text-sm mb-4">{card.set?.name} • {card.id}</div>
          
          <div className="space-y-3">
            <div className="bg-white/10 rounded p-3">
              <div className="text-sm opacity-80 mb-1">Rarity</div>
              <div className="font-medium">{card.rarity || '—'}</div>
            </div>
            
            {card.hp && (
              <div className="bg-white/10 rounded p-3">
                <div className="text-sm opacity-80 mb-1">HP</div>
                <div className="font-medium">{card.hp}</div>
              </div>
            )}
            
            {card.types && card.types.length > 0 && (
              <div className="bg-white/10 rounded p-3">
                <div className="text-sm opacity-80 mb-1">Type(s)</div>
                <div className="font-medium">{card.types.join(', ')}</div>
              </div>
            )}
            
            {card.number && (
              <div className="bg-white/10 rounded p-3">
                <div className="text-sm opacity-80 mb-1">Number</div>
                <div className="font-medium">{card.number}</div>
              </div>
            )}
          </div>
          
          <div className="mt-6">
            <Link 
              to={`/set/${encodeURIComponent(card.set?.name || '')}`} 
              className="text-blue-400 hover:text-blue-300 underline"
            >
              View Set: {card.set?.name}
            </Link>
          </div>
        </div>
        
        {/* Market Data */}
        <div className="lg:col-span-1">
          <MarketWidget 
            cardId={card.id}
            cardName={card.name}
            setName={card.set?.name}
          />
        </div>
      </div>
    </div>
  );
}


